import { render, staticRenderFns } from "./documentos_cliente.vue?vue&type=template&id=88d89796&"
import script from "./documentos_cliente.vue?vue&type=script&lang=js&"
export * from "./documentos_cliente.vue?vue&type=script&lang=js&"
import style0 from "./documentos_cliente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports